<template>
  <div class="step-confirmation">
    <div class="step-confirmation-content">
      <h1 class="step-confirmation-title">
        {{
          bookingConfirmationData?.find((item) => item.key === "title")?.value
        }}
      </h1>

      <RichText
        v-if="bookingConfirmationData"
        class="step-confirmation-description"
        :data="
          bookingConfirmationData?.find((item) => item.key === 'description')
            ?.value
        "
      />

      <div class="step-confirmation-wrapper-cta">
        <button
          class="button"
          @click="goToCart"
        >
          {{
            bookingConfirmationData?.find((item) => item.key === "cta_primary")
              ?.value
          }}
        </button>

        <button
          class="button button-outline"
          @click="goToHome"
        >
          {{
            bookingConfirmationData?.find(
              (item) => item.key === "cta_secondary"
            )?.value
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect, onMounted } from "vue";
import { useQuery } from "villus";
import RichText from "./RichText.vue";
import { useTranslationsStore } from "../stores/translations";
import { graphqlGetBookingConfirmationData } from "../utils/queryGraphql";

const translationsStore = useTranslationsStore();

const { data } = useQuery({
  query: graphqlGetBookingConfirmationData,
  variables: {
    language: translationsStore.getShopifyLocale(),
  },
});
const transformData = (data) => {
  return data.metaobjects?.edges[0].node.fields;
};

const bookingConfirmationData = ref(null);

watchEffect(() => {
  if (data.value) {
    bookingConfirmationData.value = transformData(data.value);
  }
});

const goToCart = () => {
  document.querySelector('[aria-controls="cart-drawer"]')?.click();
};

const goToHome = () => {
  window.location.href = window.location.origin;
};

onMounted(async () => {
  window.scrollTo(0, 0);
});
</script>

<style scoped>
.step-confirmation {
  background-color: rgb(var(--brand-white) / 1);
  padding: 5.5rem 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1000px) {
    padding: 1.5rem 4.5rem;
    height: 100%;
  }
}
.step-confirmation-title {
  position: relative;
  padding-top: 4.81rem;
  margin-bottom: 0;
  font-family: var(--heading-font-family), serif;
  font-weight: var(--heading-font-weight);
  font-size: 2rem;
  font-style: normal;
  line-height: 1;

  @media screen and (min-width: 1000px) {
    padding-top: 5rem;
    font-size: 2.5rem;
  }
}
.step-confirmation-description {
  color: rgba(0 0 0 / 70%);
  font-size: 1rem;
  margin-top: 1rem;
}
.step-confirmation-wrapper-cta {
  display: flex;
  flex-direction: column;
  gap: 0.62rem;
  margin-top: 2rem;
  width: 100%;

  @media screen and (min-width: 1000px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
.step-confirmation-wrapper-cta .button {
  margin: 0;
  letter-spacing: 0.03rem;
  padding: 1.25rem 2rem;
  height: auto;
  line-height: 1;

  @media screen and (min-width: 1000px) {
    flex-grow: 0;
  }
}
.step-confirmation-wrapper-cta .button-outline {
  background-color: transparent;
  border: 1px solid rgb(var(--brand-black) / 1);
  color: rgb(var(--brand-black) / 1);
}
.step-confirmation-content {
  max-width: 30rem;
  margin-inline: auto;
}
</style>
